import * as React from 'react'
import { Logger } from 'utils/logger'

import PopupBlockedError from '../PopupBlockedError'

export interface Props {}

interface State {
  error: Error | null
}

export class ErrorBoundary extends React.Component<Props, State> {
  state = {
    error: null
  } as { error: Error | null}

  static getDerivedStateFromError (error: Error) {
    return { error }
  }

  componentDidCatch (error: Error, _: React.ErrorInfo): void {
    // Can do more interesting stuff here like toast events, set redux state, etc.
    if (error instanceof PopupBlockedError) {
      Logger.error('POPUP BLOCKED ERROR', error)
    } else {
      Logger.error('GENERIC ERROR', error)
    }
  }

  render () {
    if (this.state.error) {
      // Return a blank div for now. We need to get approved content from CMS for handling this
      return <div></div>
    }
    return this.props.children
  }
}

export default ErrorBoundary
